import React from "react";
import { Box, Typography, } from "@mui/material";
import StyledNoData from "./StyledNoData";


const NoDataFound = ({ icon = "", heading, subHeading }) => {

    return (
        <StyledNoData>

            <Box className="text-container">
                <Box className="icon">{icon}</Box>
                <Typography className="heading">{heading}</Typography>
                <Typography className="subHeading">{subHeading}</Typography>
            </Box>

        </StyledNoData>
    );
};

export default NoDataFound;
